export function getKeys(obj: any): number[] {
  return Object.keys(obj)
    .map((key) => +key)
    .filter((key) => !isNaN(key));
}
